<div class="max-w-7xl mx-auto px-6 py-4">
  <div class="flex flex-col lg:flex-row lg:items-center gap-4">
    <!-- Breadcrumbs -->
    <div class="flex items-center space-x-3 text-base text-gray-600 font-serif transform transition-all duration-300">
      <a routerLink="/home" class="hover:text-gold transition-colors">Home</a>
      <span class="text-gray-400">/</span>
      <ng-container *ngFor="let child of children; let last = last">
        <a *ngIf="child.link; else noLink" [routerLink]="child.link" class="hover:text-gold transition-colors">{{ child.title }}</a>
        <ng-template #noLink>{{ child.title }}</ng-template>
        <span *ngIf="!last" class="text-gray-400">/</span>
      </ng-container>
    </div>
  </div>
</div>
